import { z } from 'zod';
import { IsoTime, Labels, ServerId } from './basics.js';
/**
 * Sent every interval (knowledge doc section 6). Names follow `<area>_<thing>_<unit>`
 * and units are always bytes, seconds or percent.
 */
export const GuardMetric = z.object({
    /**
     * Created by the agent, like an event's. Metrics previously had no identity,
     * which left a retried batch with no key to deduplicate on.
     *
     * Version 7 specifically, because it is time-ordered: index inserts append to
     * the rightmost leaf instead of scattering, which matters on the highest-volume
     * table in the schema. Note that `crypto.randomUUID()` returns v4 and is rejected.
     */
    id: z.uuidv7(),
    serverId: ServerId,
    name: z
        .string()
        .regex(/^[a-z]+(_[a-z0-9]+)+$/, 'must be snake_case as <area>_<thing>_<unit>, e.g. disk_used_pct'),
    /** zod 4 rejects NaN and Infinity by default, so no `.finite()` call is needed. */
    value: z.number(),
    labels: Labels.optional(),
    recordedAt: IsoTime,
});
//# sourceMappingURL=metric.js.map